/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

document.addEventListener('DOMContentLoaded', function() {
  var radios = document.querySelectorAll('.swatch__input');
  radios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      var colorval = document.querySelector('.swatch__input:checked').value;
      showColorImages(colorval);
      document.getElementById('swatchname').innerHTML = colorval;
    });
  });

  if (document.querySelectorAll('.swatch__input').length > 0) {
    var colorval = document.querySelector('.swatch__input:checked').value;
    showColorImages(colorval);
    document.getElementById('swatchname').innerHTML = colorval;
  }
  
});

window.onload = function() {
  if (document.querySelectorAll('.swatch__input:checked').length > 0) {
    var colorval = document.querySelector('.swatch__input:checked').value;
    showColorImages(colorval);
    
  }

// Set "In stock" as the default option in the availability filter
  if (document.querySelectorAll(".collection__filters-list .filter__input#filter-Availability-1").length > 0) {
    
     document.querySelectorAll(".collection__filters-list .filter__input#filter-Availability-1").forEach(function(felement) {
        felement.checked = true;
     });
  }

};

function showColorImages(colorname) {
  var imageallElements = document.querySelectorAll('.imageall');
  imageallElements.forEach(function(element) {
    element.classList.add('hideimage');
    element.classList.remove('is-visible');
    if (element.getAttribute('data-color') === colorname) {
      element.classList.remove('hideimage');
      element.classList.add('is-visible');
    }
  });

  if (window.innerWidth < 1008) {
    /*document.body.addEventListener('touchmove', function(e) {
      setTimeout(function() {
        console.log(2)
        var visibleImage = document.querySelector('.imageall.product-single__media-slide.is-selected.hideimage');
        if (visibleImage) {
          
          console.log(3)
          console.log(document.querySelector('.product-single__thumbnail.imageall.is-visible:first-child').getAttribute('data-id'));
          var divElement = document.querySelector('.imageall.product-single__thumbnail.is-visible:first-child');
          var event = new MouseEvent('click', {
            bubbles: 0
          });
          divElement.dispatchEvent(event);
        }
      }, 100);
    });*/
  }
}


function opennewsletter(){
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', 'Xwz57X']);
}
